var map = {
	"./br/claim.png": 48703,
	"./en/claim.png": 17086,
	"./fr/claim.png": 59707,
	"./ge/claim.png": 31431,
	"./la/claim.png": 95742,
	"./tw/claim.png": 23480,
	"./zh/claim.png": 95725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94856;